import { getContentTypeFor } from '@/util/FileUtil';

export class DocumentReference {
  entityId?: number;
  entityType?: string;
  fileName?: string;
  contentType?: string;
  typeDescription?: string;
  signedUrl?: string;

  constructor(opts?: Partial<DocumentReference>) {
    if (opts?.entityId != null) {
      this.entityId = opts.entityId;
    }
    if (opts?.entityType != null) {
      this.entityType = opts.entityType;
    }
    if (opts?.fileName != null) {
      this.fileName = opts.fileName;
    }
    if (opts?.contentType != null) {
      this.contentType = opts.contentType;
    }
    if (opts?.typeDescription != null) {
      this.typeDescription = opts.typeDescription;
    }
    if (opts?.signedUrl != null) {
      this.signedUrl = opts.signedUrl;
    }
  }

  static fromFileAndEntityId(file: File, entityId?: number) {
    return new DocumentReference({
      entityId: entityId,
      fileName: file.name,
      contentType: getContentTypeFor(file),
    });
  }
}
